const AppWrapper = ({ children }) => {
    return (
      <div className="max-w-full mx-auto ">
        {children}
      </div>
    );
  };
  
  export default AppWrapper;
  